// extracted by mini-css-extract-plugin
export default {"icon":"src-pages-SalesChannelCategory-PagesCategory-ContentCategory-HOC-css-module__icon--1-b9q"};